module.exports = __webpack_public_path__ + "img/2.7a5ecd9b.jpg";